import React from "react";
import { Modal } from "react-bootstrap";

export const BodyLoading = () => {
  return (
    <Modal.Body>
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </Modal.Body>
  );
};
